import { CONSTANTS } from "./constants.js";
import { getTokensFromRefreshToken } from "../get-auth-tokens-from-refresh-token.js";
import { Flow, initiateLoginChallenge } from "../initiate-auth-flow.js";
import { decodeJwt } from "jose";

//#region src/helpers/token.service.ts
const TOKEN_EXPIRATION_OFFSET = 3e5;
const getAccessToken = () => {
	const tokens = localStorage.getItem(CONSTANTS.tokenKey);
	const parsedTokens = JSON.parse(tokens || "{}");
	if (parsedTokens) return parsedTokens.accessToken;
};
const getRefreshToken = () => {
	const tokens = localStorage.getItem(CONSTANTS.tokenKey);
	const parsedTokens = JSON.parse(tokens || "{}");
	if (parsedTokens) return parsedTokens.refreshToken;
};
const removeLocalStorageItem = (key) => {
	return localStorage.removeItem(key);
};
const getTokenFromStorage = (key) => {
	return localStorage.getItem(key);
};
const setLocalStorageItem = (key, value) => {
	localStorage.setItem(key, value);
};
/** If there is no exp on token assume token is expired! */
const isTokenExpired = (token) => token?.exp ? Date.now() >= token.exp * 1e3 - TOKEN_EXPIRATION_OFFSET : true;
/** Checks if a non-expired access token exists in cache and returns it.
* If no access token is in cache or the token has expired attempt to use refresh token if present
* to get a new access token. If refresh token is missing or expired send user to login flow.*/
const acquireToken = async (tokenUrl, clientId, ssoUrl, redirectUri, preventRedirect) => {
	try {
		let errorMessage = "Login required";
		const tokens = localStorage.getItem(CONSTANTS.tokenKey);
		if (tokens) {
			const parsedTokens = JSON.parse(tokens);
			/** Return access token if present and not expired */
			if (parsedTokens?.accessToken) {
				const decodedAccessToken = decodeJwt(parsedTokens.accessToken);
				if (decodedAccessToken.exp && !isTokenExpired(decodedAccessToken)) return parsedTokens.accessToken;
			}
			/** Attempt to use refresh token to get a new access token*/
			if (parsedTokens?.refreshToken) {
				const refreshResult = await getTokensFromRefreshToken({
					responseCode: parsedTokens.refreshToken,
					tokenUrl,
					ssoClientId: clientId
				});
				if (!refreshResult?.error) {
					const accessToken = getAccessToken();
					if (accessToken && !isTokenExpired(decodeJwt(accessToken))) return accessToken;
				} else errorMessage = refreshResult?.error;
			}
		}
		throw new Error(errorMessage);
	} catch {
		/** When all else fails initiate new login
		* NOTE: we probably want to capture telemetry here
		*/
		const props = {
			currentUrl: window.location.pathname,
			flow: Flow.SignIn,
			mustReauthenticate: false,
			ssoUrl,
			ssoClientId: clientId,
			redirectUri
		};
		if (!preventRedirect) await initiateLoginChallenge(props);
		else return;
	}
};

//#endregion
export { acquireToken, getAccessToken, getRefreshToken, getTokenFromStorage, isTokenExpired, removeLocalStorageItem, setLocalStorageItem };